(function ($) {

    function nullOrDefault(v, converter) {
        if (v !== null && typeof (v) == 'string') {
            v = v.trim(v);
            if (v.length == 0)
                v = null;
        }
        return v !== null ? converter(v) : null;
    }

    var range = function (converterFrom, converterTo) {
        this.from = ko.observable(null);
        this.to = ko.observable(null);

        this.fromValue = ko.pureComputed(function () {
            return nullOrDefault(this.from(), converterFrom);
        }, this);

        if (converterTo == null)
            converterTo = converterFrom;

        this.toValue = ko.pureComputed(function () {
            return nullOrDefault(this.to(), converterTo);
        }, this);

        this.buildPredicate = function () {
            var _from = this.fromValue();
            var _to = this.toValue();

            var result;
            if (_from != null) {
                if (_to != null) {
                    result = function (v) { return v >= _from && v <= _to; };
                } else {
                    result = function (v) { return v >= _from; };
                }
            } else {
                if (_to != null) {
                    result = function (v) { return v <= _to; };
                } else {
                    result = function (v) { return true; };
                }
            }

            return result;
        }.bind(this);
    }

    var fileModel = function(dataUrl, fileName, fileSize) {
        this.dataUrl = dataUrl;
        this.fileName = fileName;
        this.fileSize = 0;
        if (fileSize)
            this.fileSize = fileSize;
        var parts = dataUrl.split(/[,:;]/);
        this.contentType = parts[1];
        this.base64 = parts[3];
        this.isImage = this.contentType.indexOf("image") >= 0;
    }

    var aggregatedLoadStatus = function(requests) {
        var _requests = [];
        var firstTrueDecorator = function(parameterName) {
            var self = this;
            return function(value) {
                if (value) {
                    self[parameterName](value);
                } else if (self.isAllFalse(parameterName)) {
                    self[parameterName](value);
                }
            }
        }.bind(this);

        var subscribe = function(observable, parameterName) {
            var func = firstTrueDecorator(parameterName);
            func(observable());
            return observable.subscribe(func);
        }

        this.add = function(request) {
            _requests.push({
                request: request,
                isLoadingSubscription: subscribe(request.isLoading, 'isLoading'),
                errorSubscription: subscribe(request.error, 'error'),
                requestCancelledSubscription: subscribe(request.requestCanceled, 'requestCanceled')
            });

        }.bind(this);

        this.reset = function() {
            $.each(_requests,
                function(_, r) {
                    r.isLoadingSubscription.dispose();
                    r.errorSubscription.dispose();
                    r.requestCancelledSubscription.dispose();
                });
            this.isLoading(false);
            this.error('');
            this.requestCanceled(false);
            _requests = [];
        }.bind(this);

        this.isAllFalse = function(parameterName) {
            var anyTrue = false;
            $.each(_requests,
                function(_, r) {
                    return !(anyTrue |= ko.unwrap(r.request[parameterName]));
                });
            return !anyTrue;
        }

        this.isLoading = ko.observable(false);
        this.error = ko.observable('');
        this.requestCanceled = ko.observable(false);

        if ($.isArray(requests)) {
            $.each(requests, function(_, r) { this.add(r); }.bind(this));
        }
    };

    $.extend(true, $, {
        cdh: {
            models: {
                range: range,
                dateRange: function () {
                    $.cdh.models.range.call(this, Date.parse);
                },
                amountRange: function () {
                    $.cdh.models.range.call(this, parseFloat);
                },
                fileModel: fileModel,
                aggregatedLoadStatus: aggregatedLoadStatus
            }
        }
    });
}(jQuery));
